// src/utils/api.js
import axios from 'axios';

const api = axios.create({
  baseURL: '/api',
  headers: { "Content-Type": "application/json" },
});

const handleRequestConsent = async (template_id, user_data) => {
  // if (!validateForm()) return;

  // setLoading(true);
  // setErrorMessage("");
  // setStatusMessage("Requesting consent...");
  // setActiveStep(1);

  try {
    const now = new Date();

    // For FI dates
    const oneDayBefore = new Date(now);
    oneDayBefore.setDate(now.getDate());
    const fiEndDate = oneDayBefore.toISOString().split('T')[0] + " 00:00:00.000";
    
    const fiStartDateObj = new Date(now);
    fiStartDateObj.setMonth(fiStartDateObj.getMonth() - 12);
    const fiStartDate = fiStartDateObj.toISOString().split('T')[0] + " 00:00:00.000";
    
    // For Consent dates
    const consentStart = now.toISOString().split('T')[0] + " 00:00:00.000";
    const oneYearLater = new Date(now);
    oneYearLater.setFullYear(oneYearLater.getFullYear() + 1);
    const consentEnd = oneYearLater.toISOString().split('T')[0] + " 00:00:00.000";
    
    const payload = {
      user_input: {
        phone_number: user_data.phone.replace(/\D/g, ''),
        name: user_data.name,
        email: user_data.email,
        pan: user_data.pan
      },
      consent_dates: {
        consent_start_date: consentStart,
        consent_expiry_date: consentEnd,
        fi_start_date: fiStartDate,
        fi_end_date: fiEndDate,
      },
      template_id : template_id,
      // notify_customer: true,
      // notification_mode: "SMS"
    };
    console.log(payload)
    const res = await api.post("/consent/request", payload);

    if (res.data?.status === "success" && res.data?.data?.consent_request_id) {
      const requestId = res.data.data.consent_request_id;
      const customer_id = res.data.data.customer_details.id;
      const gateway_token_id = res.data.data.gateway_token_id;
      const options = {
        environment: 'production',
        is_redirection_approach: false,
        // redirect_url: "https://www.google.com?params=test",
        is_iframe: true,
        callback: function(response) {
          console.log("Response is: ",response)
        },
        theme: {
          primaryColor: '#1F002A',
          secondaryColor: '#444444',
          fontFormat: 'truetype',
          fontFamily: 'NaviBody',
        }
      };

      var digio = new window.Digio(options)
      digio.init()
      digio.submit(requestId, customer_id, gateway_token_id)
      // onLogin({ name, email, phone, consentRequestId, customerId, gatewayTokenId });
      // setClientRequestId(requestId);
      // setStep("proceed");
      // setStatusMessage("✅ Consent requested successfully! Please approve on your Account Aggregator app.");
      return res.data?.data?.consent_request_id;
    } else {
      throw new Error("Invalid response from server");
    }
  } catch (error) {
    console.error("Consent request error:", error);
    // setErrorMessage(
    //   error.response?.data?.detail || 
    //   error.message || 
    //   "Failed to request consent. Please try again."
    // );
    // setActiveStep(0);
    // setStep("form");
  } finally {
    // setLoading(false);
  }
};


const pollConsentStatus = async (id) => {
  return new Promise((resolve, reject) => {
    let attempts = 0;
    const maxAttempts = 120;
    
    const interval = setInterval(async () => {
      attempts++;
      try {
        const res = await api.get(`/consent/request/${id}/status`);
        const status = res.data?.data?.status;
        
        // setStatusMessage(`Waiting for consent approval... (Status: ${status})`);
        
        if (status === "ACTIVE") {
          clearInterval(interval);
          resolve();
        } else if (status === "REJECTED") {
          clearInterval(interval);
          reject(new Error("Consent was rejected by user"));
        } else if (status === "EXPIRED") {
          clearInterval(interval);
          reject(new Error("Consent request expired"));
        } else if (attempts >= maxAttempts) {
          clearInterval(interval);
          reject(new Error("Consent approval timeout. Please try again."));
        }
      } catch (error) {
        clearInterval(interval);
        reject(error);
      }
    }, 5000);
  });
};

const requestFinancialInfo = async (id) => {
  const now = new Date();
  const oneDayBefore = new Date(now)
  oneDayBefore.setDate(now.getDate() - 1);
  const toDate = oneDayBefore.toISOString().split('T')[0] + " 00:00:00.000";
  const fromDate = new Date(now.setMonth(now.getMonth() - 12)).toISOString().split('T')[0] + " 00:00:00.000";

  const payload = {
    from: fromDate,
    to: toDate
  };

  const res = await api.post(`/fi/request/${id}`, payload);
  return res.data?.data?.fi_request_id;
};

const pollFinancialStatus = async (fiId) => {
  return new Promise((resolve, reject) => {
    let attempts = 0;
    const maxAttempts = 60;
    
    const interval = setInterval(async () => {
      attempts++;
      try {
        const res = await api.get(`/fi/request/${fiId}/status`);
        const status = res.data?.data?.status;
        
        // setStatusMessage(`Fetching financial data... (Status: ${status})`);
        
        if (status === "READY" || status === "DATA_AVAILABLE" || status === "PARTIAL") {
          clearInterval(interval);
          resolve();
        } else if (status === "FAILED") {
          clearInterval(interval);
          reject(new Error("Financial information request failed"));
        } else if (attempts >= maxAttempts) {
          clearInterval(interval);
          reject(new Error("Financial data fetch timeout"));
        }
      } catch (error) {
        clearInterval(interval);
        reject(error);
      }
    }, 5000);
  });
};

const fetchFinancialData = async (fiId) => {
  const res = await api.get(`/fi/fetch/${fiId}`);
  const rawData = res.data?.data?.fi || [];
  return rawData;
};

export {handleRequestConsent, pollConsentStatus, requestFinancialInfo, pollFinancialStatus, fetchFinancialData }
